import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      label: 'SSL Encrypted',
      description: '256-bit encryption'
    },
    {
      icon: 'Lock',
      label: 'Secure Login',
      description: 'Protected access'
    },
    {
      icon: 'CheckCircle2',
      label: 'Verified Platform',
      description: 'Industry certified'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
      {securityFeatures?.map((feature, index) => (
        <div
          key={index}
          className="flex items-center gap-3 p-4 rounded-lg bg-muted/50 border border-border"
        >
          <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
            <Icon name={feature?.icon} size={20} color="var(--color-primary)" />
          </div>
          <div className="min-w-0">
            <div className="text-sm font-medium text-foreground">{feature?.label}</div>
            <div className="text-xs text-muted-foreground">{feature?.description}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SecurityBadges;